import { observer } from "mobx-react";
import * as React from "react";

import { FormUpdateDefaultLanguage } from "../ui/molecules/form-update-default-language";
import { ListDepartments } from "../ui/molecules/list-departments";
import { ListShifts } from "../ui/molecules/list-shifts";
import { ListCommandButtonsDepartments } from "../ui/organisms/list-command-buttons-departments";
import { ListCommandButtonsShifts } from "../ui/organisms/list-command-buttons-shifts";
import { createUuid } from "../utils/uuid";
import { Section } from "../ui/atoms/section";
import { FormUpdateNotificationMails } from "../ui/molecules/form-update-notification-mails";
import { FormUpdateDefaultTimezone } from "../ui/molecules/form-update-default-timezone";
import { FormUpdateDefaultDateFormat } from "../ui/molecules/form-update-default-date-format";
import { FormUpdateDefaultTimeFormat } from "../ui/molecules/form-update-default-time-format";
import { articles } from "../help";
import { store } from "../store";
import { FormUpdateSSO } from "../ui/molecules/form-update-sso";
import { FusionLayout } from "@/parts/fusion-layout";
import { FormUpdateDefaultLengthUnit } from "../ui/molecules/form-update-default-length-unit";
import FormUpdateUniversalPin from "src/ui/molecules/form-update-universal-pin";

@observer
export class PageSystemWide extends React.Component {
    // Create the UUID on this level, so the button bar is able to access the same state as the list.
    private departmentsListStateId = createUuid();
    private shiftsListStateId = createUuid();

    public render(): JSX.Element {
        return (
            <FusionLayout
                suggestedHelpArticles={[
                    articles.adminSystemWideSettings,
                    articles.administratorFunctionalities,
                ]}
                breadcrumb={store.i18n.t("page.systemWide.title")}
                classic
            >
                <div className="flex flex-wrap gap-6">
                    <Section
                        withPadding
                        title={store.i18n.t("page.systemWide.department.title")}
                        icon="Group"
                    >
                        <ListCommandButtonsDepartments
                            listStateId={this.departmentsListStateId}
                            canDelete
                        />
                        <ListDepartments listStateId={this.departmentsListStateId} />
                    </Section>
                    <Section
                        withPadding
                        title={store.i18n.t("page.systemWide.shift.title")}
                        icon="WorkforceManagement"
                    >
                        <ListCommandButtonsShifts listStateId={this.shiftsListStateId} canDelete />
                        <ListShifts listStateId={this.shiftsListStateId} />
                    </Section>
                    <Section
                        withPadding
                        title={store.i18n.t("page.systemWide.general.title")}
                        icon="Settings"
                    >
                        <FormUpdateDefaultLanguage />
                        <FormUpdateDefaultTimezone />
                        <FormUpdateDefaultDateFormat />
                        <FormUpdateDefaultTimeFormat />
                        <FormUpdateDefaultLengthUnit />
                    </Section>
                    <Section
                        withPadding
                        title={store.i18n.t("page.systemWide.emails.title")}
                        icon="CreateMailRule"
                    >
                        <FormUpdateNotificationMails />
                    </Section>
                    <Section
                        withPadding
                        title={store.i18n.t("page.systemWide.sso.title")}
                        icon="FollowUser"
                    >
                        <FormUpdateSSO />
                    </Section>
                    <Section
                        withPadding
                        title={store.i18n.t("page.systemWide.universalPin.title")}
                        icon="PasswordField"
                    >
                        <FormUpdateUniversalPin />
                    </Section>
                </div>
            </FusionLayout>
        );
    }
}
